/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert between units instantly`)
};

const es_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte entre unidades al instante`)
};

const de_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten sofort umrechnen`)
};

const nl_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer direct tussen eenheden`)
};

const fr_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir entre les unités instantanément`)
};

const it_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti tra unità istantaneamente`)
};

const pt_br2_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter entre unidades instantaneamente`)
};

const pt_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter entre unidades instantaneamente`)
};

const ja_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単位をすぐに変換`)
};

const zh_uc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即时转换单位`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_nav_main_desc", locale)
	if (locale === "en") return en_uc_nav_main_desc(inputs)
	if (locale === "es") return es_uc_nav_main_desc(inputs)
	if (locale === "de") return de_uc_nav_main_desc(inputs)
	if (locale === "nl") return nl_uc_nav_main_desc(inputs)
	if (locale === "fr") return fr_uc_nav_main_desc(inputs)
	if (locale === "it") return it_uc_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_uc_nav_main_desc(inputs)
	if (locale === "pt") return pt_uc_nav_main_desc(inputs)
	if (locale === "ja") return ja_uc_nav_main_desc(inputs)
	return zh_uc_nav_main_desc(inputs)
};